/* Jungle Calling home hero — one predictable carousel model: arrows, dots, low-frequency autoplay and mobile swipe. */
(() => {
  const initHero = (root) => {
    if (!root || root.dataset.jcSplitHeroReady === 'true') return;
    const slides = [...root.querySelectorAll('[data-jc-split-slide]')];
    const dots = [...root.querySelectorAll('[data-jc-split-dot]')];
    const previous = root.querySelector('[data-jc-split-prev]');
    const next = root.querySelector('[data-jc-split-next]');
    if (slides.length < 2) return;
    root.dataset.jcSplitHeroReady = 'true';
    let index = 0;
    let autoPlay = null;
    const setIndex = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };
    const stopAutoPlay = () => { if (autoPlay) window.clearInterval(autoPlay); autoPlay = null; };
    const startAutoPlay = () => {
      stopAutoPlay();
      /* 客户要求：首屏始终自动轮播（原来若系统开启"减弱动态效果"就不会自动轮播，已去掉这个判断；
         切屏动画本身仍由 CSS 的 prefers-reduced-motion 规则负责关闭）。 */
      autoPlay = window.setInterval(() => setIndex(index + 1), 6500);
    };
    previous?.addEventListener('click', () => { setIndex(index - 1); startAutoPlay(); });
    next?.addEventListener('click', () => { setIndex(index + 1); startAutoPlay(); });
    dots.forEach((dot) => dot.addEventListener('click', () => { setIndex(Number(dot.dataset.jcSplitDot || 0)); startAutoPlay(); }));
    /* 手势/拖动切换：用 Pointer Events，手机触摸和桌面鼠标拖动都能切屏。
       （原来只监听 touchstart/touchend，所以桌面上"划不动"。）
       判定：横向位移 > 40px 且明显大于纵向位移才算切屏；纵向滑动仍交给页面滚动。 */
    let startX = null;
    let startY = null;
    let dragging = false;
    let dragged = false;
    const SWIPE_MIN = 40;
    root.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      startX = event.clientX;
      startY = event.clientY;
      dragging = true;
      dragged = false;
      stopAutoPlay();
    });
    root.addEventListener('pointermove', (event) => {
      if (!dragging || startX === null) return;
      if (Math.abs(event.clientX - startX) > 8) dragged = true;
    });
    const endDrag = (event) => {
      if (!dragging) return;
      dragging = false;
      const dx = startX === null ? 0 : event.clientX - startX;
      const dy = startY === null ? 0 : event.clientY - startY;
      startX = null;
      startY = null;
      if (Math.abs(dx) > SWIPE_MIN && Math.abs(dx) > Math.abs(dy)) {
        setIndex(dx < 0 ? index + 1 : index - 1);
      }
      startAutoPlay();
    };
    root.addEventListener('pointerup', endDrag);
    root.addEventListener('pointercancel', endDrag);
    /* 拖动过之后，抑制图片/按钮上的这次点击，避免误触发链接 */
    root.addEventListener('click', (event) => {
      if (!dragged) return;
      dragged = false;
      event.preventDefault();
      event.stopPropagation();
    }, true);
    root.addEventListener('mouseenter', stopAutoPlay);
    root.addEventListener('mouseleave', startAutoPlay);
    startAutoPlay();
  };
  const initAll = (scope = document) => scope.querySelectorAll?.('[data-jc-split-hero]').forEach(initHero);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => initAll()) : initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
